import { useTheme } from "next-themes";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useLocation } from "react-router-dom";
import { tabButton } from "../components/customStyles";

export const LearnLayout = () => {
  const [activePage, setActivePage] = useState("glossary");

  const { theme } = useTheme();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const tabs = [
    // {
    //   name: t("learn.tabs.articles"),
    //   path: "articles",
    // },
    {
      name: t("learn.tabs.glossary"),
      path: "glossary",
    },
    {
      name: t("learn.tabs.faqs"),
      path: "faqs",
    },
  ];

  return (
    <div
      className='w-100'
      style={{
        borderRadius: "20px",
        backgroundColor: theme === "dark" ? "var(--theme-dark-one)" : "var(--theme-light-one)",
      }}
    >
		<div className="d-flex">
			<div className='d-inline-flex align-items-center mx-auto p-2 flex-nowrap gap-2' style={{
				maxWidth: '100',
				overflowX: 'auto',
				scrollbarWidth: 'none',
				borderTopLeftRadius: '20px',
				borderTopRightRadius: '20px'
			}}>
				{tabs.map((tabItem, index) => {

					const fullPath = `/learn/${tabItem.path}`;
					const isActive = tabItem.path === 'articles' ? pathname === '/learn' || pathname === fullPath : pathname === fullPath;
				return (
					<Link
					className={`btn flex-shrink-0${isActive ? " active" : ""}`}
					type='button'
					to={tabItem.path}
					key={index}
					onClick={() => setActivePage(tabItem)}
					style={{
						lineHeight: "1",
						fontSize: "0.8rem",
						padding: "10px 16px 11px",
						minWidth: "62px",
						borderRadius: "99px",
						...tabButton(theme)
					}}
					>
					{tabItem.name}
					</Link>
				);
				})}
			</div>
		</div>
      <Outlet />
    </div>
  );
};
